/**
 * Internal dependencies
 */
import page from "page";

/**
 * Internal dependencies
 */
import * as actions from "state/action-types";
import { addWidgetToDashboardLayout } from "state/dashboard/actions";

const dashboardMiddleware = (store) => (next) => (action) => {
  // Force any newly created dashboard layouts to be active
  if (
    action.type === actions.SAVE_DASHBOARD_LAYOUT_SUCCESS &&
    action.payload.isNew === true
  ) {
    return page(`/decks/${action.payload.layout.id}`);
    //store.dispatch(switchLayout());
  }

  // when a dashboard is deleted; ensure that their is always an active dashboard
  if (action.type === actions.DELETE_DASHBOARD_LAYOUT_SUCCESS) {
    next(action);
    return page(`/decks`);
  }

  // when a new report is created ( and the page is on dashboard ) add the report
  // to the current active dashboard layout
  if (
    action.type === actions.SAVE_REPORT_SUCCESS &&
    action.payload.isNew === true
  ) {
    store.dispatch(addWidgetToDashboardLayout(action.payload.report.id));
  }

  return next(action);
};

export default dashboardMiddleware;
